import { LabelText, LittleText } from "../../../../components/typography";
import { OnboardingButtons } from "../../../../components/ui/button";
import { OnboardingBodyBlock } from "../settings";

export default function FinishStep() {
    return (
        <OnboardingBodyBlock className="align-items-start mt-2 flex-grow-1">
            <LabelText>Ваша CRM готова до роботи!</LabelText>
            <LittleText className="pt-2">Ми підготували систему відповідно до обраних налаштувань. Ви можете почати роботу або додати команду пізніше.</LittleText>
            <OnboardingButtons isBackBtn={true} isInviteBtn={true} state={false} path="/" finishText="Перейти до CRM" />
        </OnboardingBodyBlock>
    )
}